const LAST_CONVERSATION_KEY = 'arthelper_last_conversation_id';
const LAST_CONTENT_CONVERSATION_KEY = 'arthelper_last_content_conversation';

export const chatHistory = {
  // Set the last conversation ID
  setLastConversation: (conversationId: string) => {
    if (conversationId) {
      localStorage.setItem(LAST_CONVERSATION_KEY, conversationId);
    }
  },

  // Get the last conversation ID
  getLastConversation: (): string | null => {
    return localStorage.getItem(LAST_CONVERSATION_KEY);
  },

  // Clear the last conversation (when starting new chat or signing out)
  clearLastConversation: () => {
    localStorage.removeItem(LAST_CONVERSATION_KEY);
  },

  // Get the chat URL to navigate to (either last conversation or new chat)
  getChatUrl: (): string => {
    const lastConversation = chatHistory.getLastConversation();
    return lastConversation ? `/chat/${lastConversation}` : '/chat';
  },

  // Set the last conversation for specific content
  setLastContentConversation: (contentType: string, contentId: string, conversationId: string) => {
    if (conversationId) {
      const key = `${LAST_CONTENT_CONVERSATION_KEY}_${contentType}_${contentId}`;
      localStorage.setItem(key, conversationId);
    }
  },

  // Get the last conversation for specific content
  getLastContentConversation: (contentType: string, contentId: string): string | null => {
    const key = `${LAST_CONTENT_CONVERSATION_KEY}_${contentType}_${contentId}`;
    return localStorage.getItem(key);
  },

  // Clear the last conversation for specific content
  clearLastContentConversation: (contentType: string, contentId: string) => {
    const key = `${LAST_CONTENT_CONVERSATION_KEY}_${contentType}_${contentId}`;
    localStorage.removeItem(key);
  },

  // Get the chat URL for specific content
  getContentChatUrl: (contentType: string, contentId: string, basePath: string): string => {
    const lastConversation = chatHistory.getLastContentConversation(contentType, contentId);
    return lastConversation ? `${basePath}/${lastConversation}` : basePath;
  },

  // Clear all chat history (when signing out)
  clearAll: () => {
    chatHistory.clearLastConversation();

    // Clear all content-specific conversations
    const keys = Object.keys(localStorage);
    keys.forEach((key) => {
      if (key.startsWith(LAST_CONTENT_CONVERSATION_KEY)) {
        localStorage.removeItem(key);
      }
    });
  },
};
